import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'

export const qualificationsFields: FieldInterface[] = [
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'score',
    originKey: 'score',
    type: FIELD_TYPES.string,
  },
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
    objectType: 'EsgLabelApi',
    objectTypePath: 'src/tpbp-json-api-handler/esg/esg.api.types.ts',
  },
  {
    key: 'altLabel',
    originKey: 'alt_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'description',
    originKey: 'description',
    type: FIELD_TYPES.string,
  },
  {
    key: 'stepAnswers',
    originKey: 'step_answers',
    type: FIELD_TYPES.object,
    objectType: 'SurveyStepAnswer',
    objectTypePath:
      'src/tpbp-json-api-handler/investor-profile/investor-profile-survey.api.types',
    isMultiple: true,
  },
  {
    key: 'extra',
    originKey: 'extra',
    type: FIELD_TYPES.string,
  },
  {
    key: 'updatedAt',
    originKey: 'updated_at',
    type: FIELD_TYPES.string,
  },
  {
    key: 'esgCriteria',
    originKey: 'esg_criteria',
    type: FIELD_TYPES.object,
    objectType: 'EsgCriterias',
    objectTypePath: 'src/services/people/peopleApiServiceRiskLevels.types',
  },
]

export const qualificationsRelations: RelationInterface[] = []
